/*Define all constants*/
export const DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm";
export const DATE_FORMAT = "MM/DD/YYYY";
export const TIME_FORMAT = "HH:mm";
export const YEAR_FORMAT = "YYYY";


export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const PERSONAL_INFORMATION = "Personal Information";
export const ADDRESS_INFORMATION = "Address"
export const SUBSCRIPTION_DETAILS = "Subscription Details"
export const PROOF_OF_PAYMENT = "Proof of Payment"

export const SLASH = "/"
export const SLASH_REPLACE = "%2F"
export const SLASH_REGEX = /%2F/g

export const MODE_EDIT = "EDIT";
export const MODE_ADD = "ADD";
export const MODE_VIEW = "VIEW";
export const MODE_PENDING = "PENDING";
export const ADMIN = 1;
export const POLLTYPE_SURVEY = 1

//GENERAL
export const NO_RECORDS_FOUND = "No records found";
export const EMPTY_STRING = "";
export const SPACE_STRING = " ";
export const NOT_FOUND_INT = -1;
export const PUBLIC = "/public";
export const IS_OBJECT = "object";


export const BLACK = "#262626"
export const BLUE = "#2ca2d1";
export const RED = "#ed4e4e";
export const GREEN = "#008526";

export const SECONDARY = "secondary";
export const SUCCESS_BUTTON = "success";
export const DANGER = "danger";
export const PRIMARY = "primary";
export const YES = "Yes";
export const NO = "No";
export const LINK = "link";
export const SUBMIT = "Submit";

export const BACK = "Back";
export const CANCEL = "Cancel";
export const SAVE = "Save";
export const UPDATE = "Update";
export const DELETE = "Delete";
export const APPROVE_BUTTON = "Approve";
export const DECLINE = "Decline";
export const UPDATE_POSTED_RESULT = "Update Posted Result";

//MAGIC NUMBERS
export const USER_TYPE_2 = 2;
export const ACCESS_RIGHTS = 1;
export const SUBSCRIBED_NUMBER = 1;
export const IS_OFFICER_NUMBER = 1;
export const IS_PRIMARY_NUMBER = 1;
export const POLLTYPEID_NUMBER = 1;
export const PAGINATION_NUMBER = 1;
export const EMAIL_LENGTH = 0;
export const PASSWORD_LENGTH = 0;
export const NEWPASSWORD_LENGTH = 0;
export const CONFIRMPASSWORD_LENGTH = 0;
export const REQUESTCOUNT = 0;
export const CHECKED = 1;
export const UNCHECKED = 0;
export const PAYMENT_LENGTH = 0;
export const ERRORS_LENGTH = 0;
export const SUBSCRIBED_MEMBER = 1;
export const PARAMS = 0;
export const SUPER_ADMIN = 2;
export const IDX = 0;
export const CHOICE_ID = 0;
export const TICKETS = 0;
export const SEARCH_LENGTH = 0;
export const STORE_ID = 0;
export const SUPER_ADMIN_RIGHTS_NUMBER = 2;
export const IS_LIVE_NUMBER = 1;
export const IS_ALL_START_GAME_NUMBER = 1;

//NOTIFICATION TYPE
export const NOTIF_INFO = "info";
export const NOTIF_SUCCESS = "success";
export const NOTIF_WARNING = "warning";
export const NOTIF_ERROR = "error";
export const NOTIFICATION_TIMEOUT = 2000;

//STORE
export const DEFAULT_STORE_ID = 1;

//AD TYPE IDs
export const ADTYPE_REDEEM = 1;
export const ADTYPE_EVENT = 2;
export const ADTYPE_DONATION = 3;


//DONATION TYPE IDs
export const DONATION_TYPE_GENERIC = 0;
export const DONATION_TYPE_ADS = 1;

//MEMBERS
export const SUBSCRIBED = "Subscribed";
export const UNSUBSCRIBED = "Unsubscribed"
export const USER_MANAGEMENT = "User Management";
export const ADD_MEMBER = "Add Member";
export const EXPORT_DATA = "    Export All Data";


//POLLS
export const ONLINE = "online";
export const FINAL = "final"

//Image size
export const IMAGE_SIZE = 4000000;

//DraggableTable.js
export const STORE_LIST = "storeList";
export const ADS_LIST = "adsList";
export const STORE_SPONSORSHIP = "storeSponsorship";
export const ROWBUTTONS_LENGTH = 0;
export const ADS_TITLE = "adsTitle";
export const STORE_NAME_DRAG = "storeName";

//FormTemplate.js
export const ADTYPE_ID = "adTypeId";
export const REDEMPTION_LIMIT = "redemptionLimit";
export const ADS_PRICE = "adsPrice";
export const ISPRIMARY_USER = "isPrimaryUser";
export const SUBSCRIPTION_DATE = "subscriptionDate";
export const MEMBERS = "members";
export const NA = "N/A"
export const CALENDAR_MODEL = "CalendarModel";
export const ADMIN_RIGHTS = "adminRights";
export const SUPER_ADMIN_RIGHTS = "superAdminRights";
export const MONTHYEAR_DATEPICKER = "MM/yyyy";
export const DAYS = "days";
export const START_DATE = "Start Date";
export const END_DATE = "End Date";
export const DATE_TIMEFORMAT_TEMPLATE = "MM/DD/YYYY H:mm";
export const TIMEFORMAT_TEMPLATE = "H:mm";
export const POLLS = "polls";
export const INDUSTRY_ID = "industryId";
export const POLLTYPE_ID = "pollTypeId";
export const EMPTY = "empty";
export const ADDRESS1 = "address1";
export const EMAIL_ADDRESS = "emailAddress";
export const STORE_CODE = "storeCode";
export const IS_LIVE = "isLive";
export const IS_ALL_STAR_GAME = "isAllStarGame";

//MainHeader.js
export const SHS_ADMIN = "SHS-ADCAA-Admin";

//MemberHeader.js
export const SHS_MEMBERS = "SHS-ADCAA-Members";

//SideNavigation.js
export const ADMINISTRATOR = "Administrator";
export const SUPER_ADMINISTRATOR = "Super Administrator";
export const SHAABAA_VIDEO_CREW = "SHAABAA Video Crew";
export const MEMBERS_ROUTE = "/members";
export const STORES_ROUTE = "/stores";
export const POLLS_ROUTE = "/polls";
export const CALENDAR_ROUTE = "/calendar";
export const BANNERANNOUNCEMENT_ROUTE = "/bannerAnnouncement";
export const POPUPANNOUNCEMENT_ROUTE = "/popupAnnouncement";
export const MOBILENOTIFICATION_ROUTE = "/mobileNotification";
export const VIDEO_ROUTE = "/videoManagement";

//StoreHeader.js
export const SHSAA_STORES = "SHS-ADCAA-Stores";

//TableTemplate.js
export const STARTDATE_TEMPLATE = "startDate";
export const ENDDATE_TEMPLATE = "endDate";
export const POLLSTARTDATE_TEMPLATE = "pollStartDate";
export const POLLENDDATE_TEMPLATE = "pollEndDate";
export const CALENDARDATE_TEMPLATE = "calendarDate";
export const STARTDATETIME_TEMPLATE = "startDateTime";
export const ENDDATETIME_TEMPLATE = "endDateTime";
export const TO = "   to   ";
export const TO_DASH = "   -   ";
export const IS_SUBSCRIBED_TEMPLATE = "isSubscribed"
export const CALENDARTIME_TEMPLATE = "calendarTime";
export const SUBSCRIBED_TEMPLATE = "Subscribed";
export const UNSUBSCRIBED_TEMPLATE = "Unsubscribed";
export const CALENDAR_STATUS = "calendarStatus";
export const ONGOING = "Ongoing";
export const NOT_YET_STARTED = "Not yet started";
export const CLOSED = "Closed";
export const CALENDAR_ISOFFICER = "calendarIsOfficer";
export const IS_OFFICER = "isOfficer";
export const OFFICER = "Officer";
export const NON_OFFICER = "Non-officer";
export const MEMBER_PRIMARY = "memberPrimary";
export const MEMBER_NO = "memberNo";
export const MEMBER_NAME = "memberName";
export const COMPANY_CODE = "companyCode";
export const NO_COMPANY_CODE = "No company code";
export const OCCUPATION = "occupation";
export const NO_OCCUPATION_PROVIDED = "No occupation provided";
export const POLL_STATUS = "pollStatus";
export const POLL_START_DATE = "pollStartDate";
export const POLL_END_DATE = "pollEndDate";
export const DONE = "Done";
export const CREATED_USERID = "createdUserId";
export const SURVEY = "Survey";
export const ELECTION = "Election";
export const MESSAGE = "message";
export const POLL_TITLE = "pollTitle";
export const POLL_DESCRIPTION = "pollDescription";
export const CALENDAR_TITLE = "calendarTitle";
export const TITLE = "title";
export const ACTIONS = "Actions";
export const LIVE = "Live";
export const REPLAY = "Replay";
export const VIDEO_DATE_TEMPLATE = "dateTime";

//ADVERTISEMENTS

export const DELETE_ADS = "Delete Advertisement";
export const PENDING_ADS = "Pending Advertisement Details";
export const ADS_DETAILS = "Advertisement Details";
export const PENDING_ADS_LIST = "Pending Advertisements";
export const ADS_IMAGE = "Advertisement Image";
export const ADVERTISEMENTS = "Advertisements";
export const ADD_ADS = "Add Advertisement";
export const LIST_KEY = "adsList";

//PENDING ADS
export const PENDING_ADVERTISEMENTS = "PendingAdvertisements";

//BANNER ANNOUNCEMENTS

export const ANNOUNCEMENT = "Announcement";
export const SUBSCRIBED_MEMBERS = "Subscribed Members";
export const UNSUBSCRIBED_MEMBERS = "Unsubscribed Members";

//POPUP ANNOUNCEMENT

export const POPUP_ANNOUNCEMENT_LIST = "Popup Announcement List"
export const ADD_ANNOUNCEMENT = "Add Announcement";
export const ANNOUNCEMENT_DETAILS = "Announcement Details";

// MOBILE NOTIFICATION

export const MOBILE_NOTIFICATION_TITLE = "Mobile Push Notification";
export const SEND_MOBILE_NOTIFICATION = "Send Push Notification";

// VIDEO MANAGEMENT

export const VIDEO_MANAGEMENT_TITLE = "SHAABAA Video Management";
export const ADD_VIDEO = "Add Video";
export const VIDEO_DETAILS = "Video Details";

//CALENDAR

export const CALENDAR = "Calendar";
export const ADD_EVENT = "Add Event";
export const EVENT_DETAILS = "Event Details";

//DONATIONS

export const CONFIRM_PLEDGE = "Confirm Pledge";
export const SEND_PLEDGE = "Send Pledge";
export const TEXTAREA_PLACEHOLDER = "Enter donation purpose here. . .";
export const DONATION_PURPOSE = "Donation Purpose";
export const DONATION_DESCRIPTION = "DESCRIPTION";
export const DONATION_TITLE = "TITLE";
export const DONATION_SUMMARY = "Donation Summary";
export const DONATION_ROUTE = "/donation/response";

//LOGIN SCREEN
export const LOGIN_MEMBER_ROUTE = "/members";
export const LOGIN = "Login";
export const USERNAME = "Username";
export const PASSWORD = "Password";

//RESET PASSWORD
export const RESET_PASSWORD = "Reset Password";
export const CONFIRM_PASSWORD = "Confirm new password";
export const NEW_PASSWORD = "Enter new password";

//MEMBERS
export const MAXIMUM_FILESIZE = "Maximum File Size: 4MB";
export const PROOF_IMAGE = "Proof Image";
export const HISTORY_PAYMENTS = "History of Payments";
export const NO_HISTORY_PAYMENTS = "No History of Payment/s";
export const MEMBER_DETAILS = "Member Details";
export const STATUS = "Status :";
export const START_SUBSCRIPTION = "Start of Subscription :";
export const END_SUBSCRIPTION = "End of Subscription :";
export const RENEW_MEMBERSHIP = "Renew Membership";
export const MEMBER_RENEWAL = "Member Renewal";


//POLL
export const ADD_MANUALVOTES = "Update Manual Votes";
export const CANDIDATE_IMAGE = "Candidate Image";
export const POLL_DEFAULT_IMAGE = "https://cdn.samsung.com/etc/designs/smg/global/imgs/support/cont/NO_IMG_600x600.png";
export const MAXNUMBER_OF_CHOICES = "Maximum No. of Choices";
export const CHOICES = "Choices:";
export const VOTES = " Votes";
export const ADD_POLL = "Add Poll";
export const POLL_IMAGE = "Poll Image";
export const SEND_ONLINE_RESULT = "Send Online Result";
export const SEND_FINAL_RESULT = "Send Final Result";
export const POLL_DETAILS = "Poll Details";
export const MAXIMUM_NUMBER_OF_ANSWERS = "Maximum No. of Answers";
export const MAXIMUM_NEMBER_OF_CANDIDATES = "Maximum No. of Candidates";
export const ENTER_EMAIL_ADDRESS = "Enter email address where the result will be sent.";
export const QUESTION = "Question";
export const POSITION = "Position";
export const RESULT_AS_OF = "Result as of ";
export const POLL_LABEL = "Polls";
export const CANDIDATE_DETAILS = "Candidate Details";

//RESULT ANNOUNCEMENT

export const RESULT_ANNOUNCEMENT = "Result Announcement";

//PUBLIC STORE
export const STORE_NAME = "Store Name";

//RESERVATION

export const RESERVATION_SUMMARY = "Reservation Summary";
export const EVENT_TITLE = "EVENT TITLE";
export const EVENT_DESCRIPTION = "EVENT DESCRIPTION";
export const TOTAL = "Total :";
export const RESERVE = "Reserve";
export const PRICE = "PRICE";
export const NUMBER_OF_TICKETS = "NO. OF TICKETS";

//STORES
export const STORES = "Stores";
export const ADD_STORE = "Add Store";
export const DELETE_STORE = "Delete Store";
export const STORE_DETAILS = "Store Details";

//PAYPAL
export const PAYPAL_GRANT_TYPE = 'client_credentials'
export const SUBSCRIPTION_ACTIVE = "ACTIVE"
export const STATUS_CODE_SUCCESS = 204
export const ONE_TIME_PAYMENT = 500
export const LEAGUE_PASS_PAYMENT = 500
export const ONE_TIME_TITLE = "SHS-ADCAA Membership"
export const LEAGUE_PASS_TITLE = "League Pass payment"
export const CURRENCY = "PHP"
export const PLAN_ID = 'P-5SB128726C9799305L26N6BI'
export const IS_RECURRING = "1"
export const IS_NOT_RECURRING = "0"
export const PAYMENT_TYPE_LEAGUES_PASS = 'leaguePass'
export const PAYMENT_TYPE_MEMBERSHIP = 'membership'

//REQUEST TYPE
export const POST = "POST";
export const GET = "GET";


